import { LineChart, Line, BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { formatRp, formatDateID } from "@/lib/constants";

const money = (v) => "Rp" + Number(v || 0).toLocaleString("id-ID");

export function OmzetTrendChart({ trend }) {
  const data = (trend || []).map((t) => ({ ...t, label: formatDateID(t.tanggal).slice(0, 5) }));
  return (
    <div className="rounded-2xl border border-rose-100/70 bg-white p-4 shadow-sm">
      <h3 className="mb-3 font-heading text-base font-bold text-slate-800">Tren Omzet Harian</h3>
      {data.length === 0 ? (
        <p className="py-10 text-center text-sm text-slate-400">Belum ada data.</p>
      ) : (
        <ResponsiveContainer width="100%" height={220}>
          <LineChart data={data} margin={{ top: 5, right: 10, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f3e0e5" vertical={false} />
            <XAxis dataKey="label" tick={{ fontSize: 11, fill: "#94a3b8" }} />
            <YAxis tickFormatter={(v) => (v >= 1000 ? `${v / 1000}rb` : v)} tick={{ fontSize: 11, fill: "#94a3b8" }} width={44} />
            <Tooltip formatter={(v) => money(v)} labelStyle={{ color: "#6A38C7" }} />
            <Line type="monotone" dataKey="omzet" stroke="#7C4DE0" strokeWidth={3} dot={{ r: 3, fill: "#7C4DE0" }} />
          </LineChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}

export function PetugasBarChart({ perPetugas }) {
  const data = (perPetugas || []).map((p) => ({ nama: p.petugas, omzet: p.omzet_bersih }));
  return (
    <div className="rounded-2xl border border-rose-100/70 bg-white p-4 shadow-sm">
      <h3 className="mb-3 font-heading text-base font-bold text-slate-800">Perbandingan Omzet Petugas</h3>
      {data.length === 0 ? (
        <p className="py-10 text-center text-sm text-slate-400">Belum ada data.</p>
      ) : (
        <ResponsiveContainer width="100%" height={220}>
          <BarChart data={data} margin={{ top: 5, right: 10, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f3e0e5" vertical={false} />
            <XAxis dataKey="nama" tick={{ fontSize: 10, fill: "#94a3b8" }} interval={0} />
            <YAxis tickFormatter={(v) => (v >= 1000 ? `${v / 1000}rb` : v)} tick={{ fontSize: 11, fill: "#94a3b8" }} width={44} />
            <Tooltip formatter={(v) => money(v)} />
            <Bar dataKey="omzet" fill="#7C4DE0" radius={[6, 6, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}
